import React, { useEffect, useState, useMountEffect } from 'react';
import { Button, Col, Table, Row, notification } from 'antd';
import ModalCreateDriver from "../../../../modals/create-driver";
import ModalEditDriver from "../../../../modals/edit-driver";
import Spinner from "../../../../spinner";
import { tableHelper } from '../../../../../helpers';
import { companyService } from "../../../../../services";
import ModalShowCarParkInfo from "../../../../modals/show-car-park-info";
import ModalChangeUserLogin from "../../../../modals/change-user-login";
import i18n from '../../../../../i18n';

export default function Drivers({ companyId }) {

	const [showModalCreateDriver, setShowModalCreateDriver] = useState(false);
	const [showModalEditDriver, setShowModalEditDriver] = useState(false);
	const [showModalEdit, setShowModalEdit] = useState(false);
	const [isShowModal, setIsShowModal] = useState(false);

	const [loading, setLoading] = useState(false);
	const [isNeedUpdateList, setIsNeedUpdateList] = useState(true);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [data, setData] = useState([]);
	const [showUserChangeLoginModal, setShowUserChangeLoginModal] = useState(null);

	let bigButtonStyle = { width: '190px', height: '40px', background: '#1CAA53', position: 'static', borderRadius: '10px', float: 'right', borderColor: "#1CAA53" };
	let editButtonStyle = { fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', fontSize: '10px', lineHeight: '12px', color: '#2B3F63', borderRadius: '0px', borderColor: 'transparent', background: "transparent", boxShadow: 'none', padding: "0px" };
	let deleteButtonStyle = { fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', fontSize: '10px', lineHeight: '12px', color: '#EB5757', borderRadius: '0px', borderColor: 'transparent', background: "transparent", boxShadow: 'none' };

	useEffect(() => {
		if (isNeedUpdateList) {
			setLoading(true);
			setIsNeedUpdateList(false);
			companyService.getCompanyDrivers().then((response) => {
				setData(response);
				setDataLoaded(true);
				setLoading(false);
			})
		}
	}, [isNeedUpdateList]);


	const columns = [
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.surname.title'),
			dataIndex: 'surname',
			key: 'surname',
			width: '14%',
			sorter: (a, b) => {
				return a.surname.localeCompare(b.surname);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.firstName.title'),
			dataIndex: 'firstName',
			key: 'firstName',
			width: '12%',
			sorter: (a, b) => {
				return a.firstName.localeCompare(b.firstName);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.lastName.title'),
			dataIndex: 'lastName',
			key: 'lastName',
			width: '15%',
			sorter: (a, b) => {
				return a.lastName.localeCompare(b.lastName);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.username.title'),
			dataIndex: 'username',
			key: 'username',
			width: '15%',
			sorter: (a, b) => {
				return a.username.localeCompare(b.username);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.phone.title'),
			dataIndex: 'phone',
			key: 'phone',
			width: '12%',
			sorter: (a, b) => {
				return Number(a.phone) - Number(b.phone);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.regCountry.title'),
			dataIndex: 'regCountry',
			key: 'regCountry',
			width: '10%',
			sorter: (a, b) => {
				return a.regCountry.localeCompare(b.regCountry);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.deliveryCount.title'),
			dataIndex: 'deliveryCount',
			key: 'deliveryCount',
			width: '10%',
			sorter: (a, b) => {
				return Number(a.deliveryCount) - Number(b.deliveryCount);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.salary.title'),
			dataIndex: 'salary',
			key: 'salary',
			width: '12%',
			sorter: (a, b) => {
				return Number(a.salary) - Number(b.salary);
			},
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.questionnaire.title'),
			key: 'questionnaire',
			render: (data) => {
				return (
					<React.Fragment>
						<Button
							htmlType="button"
							onClick={() => setShowModalEdit(data.id)}
							size="small"
							style={editButtonStyle}>
              {i18n.t('main.buttons.view')}
						</Button>
						<ModalShowCarParkInfo
							isShow={(showModalEdit === data.id)}
							onCloseModal={(isNeedRefresh = false) => {
								setShowModalEdit(false);
								setLoading(isNeedRefresh);
								setIsNeedUpdateList(isNeedRefresh);
							}}
							driverId={data.id}
							info={data}
						/>
					</React.Fragment >
				);
			}
		},
		{
			title: i18n.t('companyPage.carPark.tabs.drivers.table.edit.title'),
			key: 'edit',
			render: (data) => {
				return (
					<React.Fragment>
						<Button
							htmlType="button"
							onClick={() => setShowModalEditDriver(data.id)}
							size="small"
							style={editButtonStyle}>
							{i18n.t('main.buttons.edit')}
						</Button>
						<ModalEditDriver
							isShow={(showModalEditDriver === data.id)}
							onCloseModal={() => {
								setShowModalEditDriver(null);
								setLoading(true);
								setIsNeedUpdateList(true);
							}}
							driverId={data.id}
						/>
					</React.Fragment >
				);
			}
		},
		{
			title: '',
			key: 'change-login',
			render: (data) => {
				return (
					<React.Fragment>
						{data.userId !== null && <>
						<Button
							htmlType="button"
							size="small"
							style={editButtonStyle}
							onClick={() => {
								setShowUserChangeLoginModal(data.userId);
							}}>
              {i18n.t('companyPage.carPark.tabs.drivers.buttons.edit')}
						</Button>
						<ModalChangeUserLogin
							id={data.userId}
							isShow={showUserChangeLoginModal === data.userId}
							setIsShow={() => {
								setShowUserChangeLoginModal(null)
							}}
							setNeedUpdateList={setIsNeedUpdateList}
						/> </>}
					</React.Fragment >
				);
			}
		},
		/* {
			title: '',
			key: 'delete',
			render: (data) => {
				return (
					<React.Fragment>
						<Button
							htmlType="button"
							size="small"
							style={deleteButtonStyle}
						>
							{i18n.t('main.buttons.delete')}
						</Button>
					</React.Fragment>
				);
			}
		} */
	];

	return (
		<React.Fragment>
			<Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
				<Row style={{ marginBottom: "25" }}>
					<Col className={"content-header"} style={{ marginBottom: "0px" }} span={12}>{i18n.t('companyPage.carPark.tabs.drivers.title')}</Col>
					<Col span={8} style={{ marginBottom: "0px" }} offset={4}>
						<Button type="primary"
							htmlType="button"
							style={bigButtonStyle}
							onCloseModal={() => {
								setIsNeedUpdateList(true);
							}}
							onClick={() => {
								setIsShowModal(false);
								setShowModalCreateDriver(true);
							}}>
              {i18n.t('companyPage.carPark.tabs.drivers.buttons.create')}
						</Button>
						<ModalCreateDriver
							companyId={companyId}
							isShow={showModalCreateDriver}
							setIsShow={setShowModalCreateDriver}
							setShowAttachDriverOrderDelivery={setIsShowModal}
							setIsNeedUpdateList={setIsNeedUpdateList}
						/>
					</Col>
				</Row>
				<Col span={24}>
					<Table
						style={{ minWidth: "700px" }}
						columns={columns}
						dataSource={data}
						locale={{ emptyText: i18n.t('main.empty') }}
						rowKey="myid"
						size="small"
						pagination={{
							pageSize: 50,
						}}
						className="car-park"
						rowClassName={(record, index) => ("car-park-row")
						}
					/>

				</Col>
			</Spinner>
		</React.Fragment >
	);
}
